import moment from 'moment'
import _ from 'lodash'

const descTruncateLength = 120

export const transform = (item) => {
  const startDateObject = moment(item.start, 'YYYY-MM-DD hh:mm:ss').startOf('day').toDate()
  const endDateObject = moment(item.end, 'YYYY-MM-DD hh:mm:ss').endOf('day').toDate()
  const nowMomentDate = getMomentCurrentDate()
  return {
    eventId: item.id,
    title: item.title,
    start: item.start,
    end: item.end,
    startDateObject,
    endDateObject,
    timeZone: item.timeZone,
    allDay: item.allDay,
    hasElapsed: nowMomentDate.isAfter(moment(endDateObject)),
    description: item.description,
    descriptionTruncated: _.truncate(item.description, { length: descTruncateLength + 3 }),
    location: item.location,
    eventType: item.eventType,
    meetingType: item.meetingType,
    outlookButton: item.outlookButton,
    audience: item.audience,
    urls: item.urls,
    posts: item.posts,
    recurrence: item.recurrence,
    startTime: item.startTime,
    endTime: item.endTime,
    isFavorite: item.isFavorite,
    groupId: item.group?.id,
    eventDurationInDays:
      moment(item.end, 'YYYY-MM-DD hh:mm:ss').diff(moment(item.start, 'YYYY-MM-DD hh:mm:ss'), 'days') + 1,
    multiDay: isMultiDay(moment(item.start, 'YYYY-MM-DD hh:mm:ss'), moment(item.end, 'YYYY-MM-DD hh:mm:ss')),
  }
}

export const transformMany = (items) => {
  const uniqGroupsIds = _(items).map('group.id').uniq().compact().value()
  const transformedEvents = items.map((item) => transform(item))
  const groupsInfo = uniqGroupsIds.reduce(
    (acc, groupId) => ({
      ...acc,
      [groupId]: getGroupInfo(getAllEventsFromGroup(groupId, transformedEvents)),
    }),
    {}
  )
  return enrichTransformedEventsWithGroupInfo(transformedEvents, groupsInfo)
}

function enrichTransformedEventsWithGroupInfo(transformedEvents, groupsInfo) {
  return transformedEvents.map((transformedEvent) => {
    if (!transformedEvent.groupId) {
      return {
        ...transformedEvent,
        isInGroup: false,
      }
    }

    return {
      ...transformedEvent,
      ...groupsInfo[transformedEvent.groupId],
    }
  })
}

function getGroupInfo(groupEvents) {
  const groupOrderedDates = _(groupEvents)
    .orderBy(({ startDateObject }) => moment(startDateObject, 'YYYY-MM-DD hh:mm:ss').toDate())
    .map('startDateObject')
    .value()
  const areGroupDaysConsecutive = areDaysConsecutive(groupOrderedDates)
  const shouldGroupBeBubbled = areGroupDaysConsecutive && isGroupSameEventType(groupEvents)
  const groupStartDate = _.first(groupOrderedDates)
  const groupEndDate = _.last(groupOrderedDates)
  return {
    isInGroup: true,
    areGroupDaysConsecutive,
    groupOrderedDates,
    shouldGroupBeBubbled,
    groupStartDate,
    groupEndDate,
  }
}

function areDaysConsecutive(orderedDates) {
  const daysDiff = orderedDates.map((event) =>
    moment(event, 'YYYY-MM-DD hh:mm:ss').diff(moment(orderedDates[0], 'YYYY-MM-DD hh:mm:ss'), 'days')
  )

  return isArrayConsecutive(daysDiff)
}

function isGroupSameEventType(groupEvents) {
  return _(groupEvents).map('eventType').uniq().value().length === 1
}

function isArrayConsecutive(array) {
  const differencesArray = array.map((currEl, index, originalArray) =>
    index === 0 ? 1 : currEl - originalArray[index - 1]
  )
  return differencesArray.every((value) => value === 1)
}

function getAllEventsFromGroup(groupId, allEvents) {
  return allEvents.filter((event) => event.groupId === groupId)
}

function isMultiDay(start, end) {
  return !start.isSame(end, 'day')
}

const getMomentCurrentDate = _.memoize(() => {
  return moment().endOf('day')
})
